import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol class=\"icon icon-tabler icon-tabler-logout\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"logout\"><path d=\"M0 0h24v24H0z\" fill=\"none\" stroke=\"none\" /><path d=\"M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2\" /><path d=\"M7 12h14l-3 -3m0 6l3 -3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol